export default __webpack_public_path__ + "static/media/Internet.19fcb7c0.png";